const getPaperFormat = (dimension = false) => {
  let paperFormat = [
    { label: 'A0 (84.1cm x 118.9cm)', value: 'A0:84.1:118.9' },
    { label: 'A1 (59.4cm x 84.1cm)', value: 'A1:59.4:84.1' },
    { label: 'A2 (42.0cm x 59.4cm)', value: 'A2:42.0:59.4' },
    { label: 'A3 (29.7cm x 42.0cm)', value: 'A3:29.7:42.0' },
    { label: 'A4 (21.0cm x 29.7cm)', value: 'A4:21.0:29.7' },
    { label: 'A5 (14.8cm x 21.0cm)', value: 'A5:14.8:21.0' },
    { label: 'A6 (10.5cm x 14.8cm)', value: 'A6:10.5:14.8' },
    { label: 'Letter (21.6cm x 27.9cm)', value: 'Letter:21.6:27.9' },
    { label: 'Legal (21.6cm x 35.6cm)', value: 'Legal:21.6:35.6' },
    { label: 'Tabloid (27.9cm x 43.2cm)', value: 'Tabloid:27.9:43.2' },
    { label: 'Ledger (43.2cm x 27.9cm)', value: 'Ledger:43.2:27.9' },
  ];
  if (!dimension) {
    paperFormat = paperFormat.map((format) => ({
      label: format.label,
      value: format.value.split(':')[0],
    }));
  }
  return paperFormat;
};

export const modalActions = [
  {
    name: 'showModal',
    label: 'Open Modal',
    args: [
      {
        name: 'modal',
        label: 'Modal',
        type: 'dropdown',
        optionsType: 'modalApi',
        value: '',
      },
      {
        name: 'getItemIdFrom',
        label: 'Get Item Id From',
        type: 'dropdown',
        optionsType: 'getItemIdFromApi',
        value: '',
      },
      {
        name: 'browserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'browserStorageLocation',
        optionsType: 'browserStorageLocationOptionsApi',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'browserStorageItemIdPath',
        label: 'Browser Storage Key',
        type: 'text',
        placeholder: 'Item Id Path (ex. sessionKey.uuid)',
        value: '',
      },
      {
        name: 'enableMultiSelect',
        label: 'Enable Bulk Selection (append Selected Item Ids to Form)',
        type: 'boolean',
        value: '',
        custom: [],
      },
    ],
  },
  {
    name: 'closeModal',
    label: 'Close Modal',
    args: [],
  },
  {
    name: 'conditionalOpenModal',
    label: 'Conditional Open Modal',
    args: [
      {
        name: 'collectionFrom',
        label: 'Collection From',
        type: 'radio',
        optionsType: '',
        value: 'collections',
      },
      {
        name: 'page',
        label: 'Page',
        type: 'dropdown',
        optionsType: '',
        options: [],
        value: '',
      },
      {
        name: 'collectionName',
        label: 'Collection',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'fieldName',
        label: 'Collection Field',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'displaySubPage',
    label: 'Show Sub Page',
    args: [
      {
        name: 'source',
        label: 'Source',
        type: 'dropdown',
        optionsType: 'sourceApi',
        options: [],
        value: 'PAGE',
      },
      {
        name: 'page',
        label: 'Page',
        type: 'dropdown',
        options: [],
        optionsType: 'hideComponentPageApi',
        value: '',
      },
      {
        name: 'pageSubPageComponents',
        label: 'Page Components',
        type: 'dropdown',
        optionsType: 'pageSubPageComponentApi',
        options: [],
        value: '',
      },
      {
        name: 'subPage',
        label: 'Sub Page',
        type: 'dropdown',
        optionsType: 'subPageApi',
        value: '',
      },
      {
        name: 'getItemIdFrom',
        label: 'Get Item Id From',
        type: 'dropdown',
        optionsType: 'getItemIdFromApi',
        value: '',
      },
      {
        name: 'browserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'browserStorageLocation',
        optionsType: 'browserStorageLocationOptionsApi',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'browserStorageItemIdPath',
        label: 'Browser Storage Key',
        type: 'text',
        placeholder: 'Item Id Path (ex. sessionKey.uuid)',
        value: '',
      },
    ],
  },
  {
    name: 'conditionalOpenSubpage',
    label: 'Conditional Open Subpage',
    args: [
      {
        name: 'collectionFrom',
        label: 'Collection From',
        type: 'radio',
        optionsType: '',
        value: 'collections',
      },
      {
        name: 'page',
        label: 'Page',
        type: 'dropdown',
        optionsType: '',
        options: [],
        value: '',
      },
      {
        name: 'collectionName',
        label: 'Collection',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'fieldName',
        label: 'Collection Field',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'pageFrom',
        label: 'Page',
        type: 'dropdown',
        options: [],
        optionsType: 'showComponentPageApi',
        value: '',
      },
      {
        name: 'pageSubPageComponents',
        label: 'Page Components',
        type: 'dropdown',
        optionsType: 'pageSubPageComponentApi',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'displayCustomComponent',
    label: 'Show Custom Component',
    args: [
      {
        name: 'page',
        label: 'Page',
        type: 'dropdown',
        options: [],
        optionsType: 'showComponentPageApi',
        value: '',
      },
      {
        name: 'pageCustomComponentComponents',
        label: 'Page Components',
        type: 'dropdown',
        optionsType: 'pageCustomComponentComponentApi',
        options: [],
        value: '',
      },
      {
        name: 'customComponent',
        label: 'Custom Component',
        type: 'dropdown',
        optionsType: 'customComponentApi',
        value: '',
      },
    ],
  },
  {
    name: 'generatePdfFromSnippet',
    label: 'Generate PDF from PDF Template',
    args: [
      {
        name: 'pdfTemplate',
        label: 'PDF Template',
        type: 'dropdown',
        optionsType: 'pdfTemplateApi',
        value: '',
      },
      {
        name: 'format',
        label: 'Format',
        type: 'dropdown',
        optionsType: 'formatApi',
        options: getPaperFormat(),
        value: 'A4',
      },
      {
        name: 'printBackground',
        label: 'Print Background',
        type: 'boolean',
        optionsType: 'printBackgroundApi',
        value: true,
      },
      {
        name: 'landscape',
        label: 'Landscape orientation',
        type: 'boolean',
        optionsType: 'landscapeApi',
        value: false,
      },
      {
        name: 'marginTop',
        label: 'Margin Top (in cm)',
        type: 'number',
        optionsType: 'marginTopApi',
        value: 0,
      },
      {
        name: 'marginBottom',
        label: 'Margin Bottom (in cm)',
        type: 'number',
        optionsType: 'marginBottomApi',
        value: 0,
      },
      {
        name: 'marginLeft',
        label: 'Margin Left (in cm)',
        type: 'number',
        optionsType: 'marginLeftApi',
        value: 0,
      },
      {
        name: 'marginRight',
        label: 'Margin Right (in cm)',
        type: 'number',
        optionsType: 'marginRightApi',
        value: 0,
      },
      {
        name: 'saveToCollection',
        label: 'Add To Collection',
        type: 'boolean',
        value: false,
      },
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'collectionField',
        label: 'Select Field',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'generatePdfFromSection',
    label: 'Generate PDF from Page/Snippet Component',
    args: [
      {
        name: 'source',
        label: 'Source',
        type: 'dropdown',
        optionsType: 'sourceApi',
        options: [],
        value: 'PAGE',
      },
      {
        name: 'showComponentPage',
        label: 'Page',
        type: 'dropdown',
        optionsType: 'showComponentPageApi',
        options: [],
        value: '',
      },
      {
        name: 'showComponents',
        label: 'Show Component',
        type: 'dropdown',
        optionsType: 'showPageComponents',
        options: [],
        value: '',
      },
      {
        name: 'format',
        label: 'Format',
        type: 'dropdown',
        optionsType: 'formatApi',
        options: getPaperFormat(true),
        value: 'A4:21.0:29.7',
      },
      {
        name: 'landscape',
        label: 'Landscape orientation',
        type: 'boolean',
        optionsType: 'landscapeApi',
        value: false,
      },
      {
        name: 'marginTop',
        label: 'Margin Top (in cm)',
        type: 'number',
        optionsType: 'marginTopApi',
        value: 0,
      },
      {
        name: 'marginBottom',
        label: 'Margin Bottom (in cm)',
        type: 'number',
        optionsType: 'marginBottomApi',
        value: 0,
      },
      {
        name: 'marginLeft',
        label: 'Margin Left (in cm)',
        type: 'number',
        optionsType: 'marginLeftApi',
        value: 0,
      },
      {
        name: 'marginRight',
        label: 'Margin Right (in cm)',
        type: 'number',
        optionsType: 'marginRightApi',
        value: 0,
      },
      {
        name: 'saveToCollection',
        label: 'Add To Collection',
        type: 'boolean',
        value: false,
      },
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'collectionField',
        label: 'Select Field',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'generatePdfFromAgreementTemplate',
    label: 'Generate PDF from Agreement Template',
    args: [
      {
        name: 'agreementTemplate',
        label: 'Agreement Template',
        type: 'dropdown',
        optionsType: 'agreementTemplatePdfApi',
        value: '',
      },
      {
        name: 'format',
        label: 'Format',
        type: 'dropdown',
        optionsType: 'formatApi',
        options: getPaperFormat(),
        value: 'A4',
      },
      {
        name: 'marginTop',
        label: 'Margin Top (in cm)',
        type: 'number',
        optionsType: 'marginTopApi',
        value: 0,
      },
      {
        name: 'marginBottom',
        label: 'Margin Bottom (in cm)',
        type: 'number',
        optionsType: 'marginBottomApi',
        value: 0,
      },
      {
        name: 'marginLeft',
        label: 'Margin Left (in cm)',
        type: 'number',
        optionsType: 'marginLeftApi',
        value: 0,
      },
      {
        name: 'marginRight',
        label: 'Margin Right (in cm)',
        type: 'number',
        optionsType: 'marginRightApi',
        value: 0,
      },
      {
        name: 'saveToCollection',
        label: 'Add To Collection',
        type: 'boolean',
        value: false,
      },
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'collectionField',
        label: 'Select Field',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'displayToolTip',
    label: 'Display Tooltip',
    args: [
      {
        name: 'toolTip',
        label: 'ToolTip Template',
        type: 'dropdown',
        optionsType: 'toolTipApi',
        options: [],
        value: '',
      },
      {
        name: 'placement',
        label: 'Position',
        type: 'dropdown',
        optionsType: 'toolTipPosition',
        options: [],
        value: '',
      },
      {
        name: 'theme',
        label: 'Theme',
        type: 'dropdown',
        optionsType: 'toolTipTheme',
        options: [],
        value: '',
      },
      {
        name: 'animation',
        label: 'Animation',
        type: 'dropdown',
        optionsType: 'toolTipAnimation',
        options: [],
        value: '',
      },
      {
        name: 'followCursor',
        label: 'Follow Cursor',
        type: 'dropdown',
        optionsType: 'toolTipFollowCursor',
        options: [],
        value: '',
      },
      {
        name: 'maxWidth',
        label: 'Max Width',
        type: 'number',
        value: '',
      },
      {
        name: 'showDelay',
        label: 'Show Delay',
        type: 'number',
        value: '',
      },
      {
        name: 'hideDelay',
        label: 'Hide Delay',
        type: 'number',
        value: '',
      },
      {
        name: 'interactive',
        label: 'Interactive',
        type: 'boolean',
        value: '',
      },
    ],
  },
  {
    name: 'runJavaScriptCode',
    label: 'Run JavaScript Code',
    args: [
      {
        name: 'runJavaScript',
        label: 'Run JavaScript',
        type: 'editor',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
];
